import { render } from "./DownloadApp.vue?vue&type=template&id=fec63f42"
import script from "./DownloadApp.vue?vue&type=script&lang=js"
export * from "./DownloadApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__